const awsConfig = {
  bucket: 'apm-user-images',
  region: 'us-east-2',
  userPoolId: 'us-east-2_s9IKd8JBp',
  userPoolWebClientId: '37oumphpb1gbrpt5dquqs0e7ql',
  identityPoolId: 'us-east-2:80ad06f7-331c-4650-b4f3-436441f68987',
};

export default awsConfig;
